import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  NgModule,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/feature-routing-enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { trackEvent } from '@wizbii/utils/tracking';
import { Observable, fromEvent } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements AfterViewInit {
  readonly #router = inject(Router);
  readonly #cdr = inject(ChangeDetectorRef);
  readonly #breakpointsService = inject(BreakpointsService);

  menuOpen = false;

  isSticky$!: Observable<boolean>;

  currentRoute!: string;
  FeaturesRoutingEnum = FeaturesRoutingEnum;
  applicationId = environment.applicationId;

  trackEvent = trackEvent;

  @ViewChild('nav')
  nav!: ElementRef;

  @Output() openMobileMenu: EventEmitter<boolean> = new EventEmitter();

  get isHome(): boolean {
    return this.currentRoute ? this.currentRoute.split('#')[0].split('?')[0] === '/' : true;
  }

  get isWeb$(): Observable<boolean> {
    return this.#breakpointsService.isWeb$;
  }

  get isMobile$(): Observable<boolean> {
    return this.#breakpointsService.isMobile$;
  }

  ngAfterViewInit(): void {
    this.isSticky$ = fromEvent(window, 'scroll', { passive: true }).pipe(
      map(() => this.nav.nativeElement.getBoundingClientRect().top <= 10),
      tap(() => {
        this.#cdr.detectChanges();
      })
    );

    this.#router.events
      .pipe(
        untilDestroyed(this),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
        this.#cdr.detectChanges();
      });
  }

  navLinkClick(menuOpen: boolean | null): void {
    if (menuOpen !== null) {
      this.menuOpen = menuOpen;
    }
  }
}

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [HeaderComponent],
})
export class HeaderModule {}
